<template>
  <div class="content md flex-box vertical">
    <div class="content-title">
      <div class="content-title-text">官方日程</div>
    </div>
    <div class="gap top"></div>
    <div class="flex-grow scroll-area activity-date-list">
      <a-card
        class="activity-date-item"
        v-for="s in list"
        :title="`日期：${s.date}`"
        :key="s.date">
        <a-table
          :columns="columns"
          :data-source="s.list"
          :pagination="false"
          bordered
          v-if="s.list && s.list.length > 0"></a-table>
      </a-card>
    </div>
  </div>
</template>

<script>
import {getActivityDayList} from "../../../common/activity/activity";

export default {
    name: "ActivitySchedule",
    data() {
        return {
            columns: [
                { title: '时间', dataIndex: 'showTime'},
                { title: '活动安排', dataIndex: 'activity_arrange' },
                { title: '活动地点', dataIndex: 'location' },
            ]
        }
    },
    computed: {
        activity() {
            return this.$store.getters.activity;
        },
        list() {
            let res = [];
            const activity = this.activity;
            if(activity) {
                res = getActivityDayList(activity, activity.group, true);
            }
            return res;
        }
    }
};
</script>

<style lang="less">
  .activity-date-item {
    &:not(:first-of-type) {
      margin-top: 16px;
    }
  }
</style>
